<template>
    <div id="story-step-component">
      <div class="story-text" v-bind:class="{ noimage: !hasImage }">
        <transition name="fade-in">
          <div v-if="showTitle">
            <div class="quote-icon" v-if="!hasImage"/>
            <h1>{{title}}</h1>
          </div>
        </transition>
        <transition name="fade-in-delay">
          <div v-if="showTitle" class="par">
            {{text}}
            <share-buttons v-if="isLast"></share-buttons>
          </div>
        </transition>

      </div>
      <transition name="fade-image">
        <div class="story-img" v-if="hasImage" v-show="imgLoaded" >
           <img v-if="showTitle" v-bind:src="imageUrl" v-on:load="onImgLoaded" />
           <div class="source" v-if="source">{{$t('source')}}: <a :href="source" target="_blank">{{source}}</a></div>
        </div>
      </transition>
    </div>
</template>

<script>
  import ShareButtons from './ShareButtons'

  export default {
    name: "story-step",
    props: ['data', 'stepId', 'isLast'],
    components: {
      ShareButtons
    },
    data () {
      return {
        showTitle: false,
        showText: false,
        imgLoaded: false
      }
    },
    computed: {
      isMobile(){
        return this.$store.state.isMobile
      },
      hasImage() {
        return this.imageUrl != ''
      },
      title (){
        if (this.$i18n.locale == 'ar'){
          return this.data.title_AR
        }
        return this.data.title_EN
      },
      text () {
        if (this.$i18n.locale == 'ar'){
          return this.data.text_AR
        }
        return this.data.text_EN
      },
      imageUrl () {
        if (this.isMobile){
          return this.$i18n.locale == 'ar'? this.data.image_link_mobile_ar : this.data.image_link_mobile_en
        }
        return this.$i18n.locale == 'ar'?  this.data.image_link_desktop_ar : this.data.image_link_desktop_en
      },
      source () {
        return this.$i18n.locale == 'ar'?  this.data.source_ar : this.data.source_en
      }
    },
    methods: {
      onImgLoaded () {
        this.imgLoaded = true
      }
    },
    mounted () {
      this.showTitle = true
    },
  }
</script>

<style scoped>
.ar .par, .ar h1{
  text-align: right
}

.ar .source{
  text-align: center
}

#story-step-component{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-items: center;
}
.story-text{
  width: 100%;
}
.story-img{
  text-align: center;
  width: 100%;
}
.story-img img{
  max-width: 100%;
}
.story-img .source{
  font-size: 11px;
  font-style: italic;
  margin-right: 40px;
  margin-left: 40px;
  margin-bottom: 65px;
}

.quote-icon{
  margin-top: 50px;
  background: url("~@/../static/icons/quote-icon.png") center center no-repeat;
  width: 100%;
  min-height: 45px;
}
h1{
  font-size: 24px;
  text-align: left;
}
.noimage h1{
  color: #393939;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  font-weight: bold;
  margin-top: 50px;
}
.par{
  color: #393939;
  text-align: left;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 35px;
}
.noimage .par{
  text-align: center;
}


@media only screen and (min-width: 768px) {
  #story-step-component {
    flex-direction: row;
  }
  .ar #story-step-component {
    flex-direction: row-reverse;
  }
  .ar .source{
    text-align: left
  }
  .story-text{
    width: 30%;
    margin-top: 40px;
  }
  .story-text.noimage {
    width: 100%;
    margin: 0px 25%;
  }
  .story-img{
    text-align: right;
    width: 70%;
  }
  .story-img img{
    max-height: calc(100vh - 230px);
    max-width: 90%;
  }
  .ar .story-img{
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StoryStep.vue